import { render } from "./admin-permission.vue?vue&type=template&id=64c76fc2&scoped=true&ts=true"
import script from "./admin-permission.vue?vue&type=script&lang=ts"
export * from "./admin-permission.vue?vue&type=script&lang=ts"

import "./admin-permission.vue?vue&type=style&index=0&id=64c76fc2&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c76fc2"]])

export default __exports__